import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginVm } from '../../../Model/LoginVM';
import { CoreService } from '../../../Shared/Services/core.service';
import { LoginService } from '../../../Services/login.service';
import { AuthService } from '../../../Shared/Services/auth.service';
import { SharedService } from '../../../Shared/Services/shared.service';
import {WindoRexVM} from "../../../Model/WindoRexVM";
import {InvitationsService} from "../../../Services/invitations.service";
import {CustomToastrService} from "../../../Shared/Services/custom-toastr.service";

@Component({
  selector: 'app-invitations-done',
  templateUrl: './done.component.html',
  styleUrl: './done.component.scss'
})
export class DoneComponent {
  formErrors: string[] = [];
  guestData: WindoRexVM = {} as WindoRexVM;
  options: any;
  id: string | null = null;
  selectedState: {'state': string, 'citites': string[]} = {} as {'state': string, 'citites': string[]};


  constructor(private toastrService: CustomToastrService, private api: InvitationsService, private route:ActivatedRoute) {
  }

  ngOnInit(){
    this.id = this.route.snapshot.paramMap.get('id')
  }

  get url(): string{
    return this.id ? `${this.api.APIBase}/${this.id}` : '';
  }

  copyUrl(): void{
    let self = this;
    navigator.clipboard.writeText(this.url).then(function() {
      self.toastrService.showSuccessToast('UrlCopied',' ');
    });
  }
}
